import qs from 'qs';
import { Navigate, Route, Routes, useLocation, useNavigate, useResolvedPath } from 'react-router-dom';
import { QRCodeType } from '../../API/Enums';
import { useLocalization } from '../../context/Localization/localization';
import { useHasDmsVehicleKey } from '../../context/Appointment/appointment';
import { Mileage } from '../Appointment/Mileage';
import { TagNumber } from '../Appointment/TagNumber';
import { ConfirmAppointmentInformation } from './ConfirmAppointmentInformation/ConfirmAppointmentInformation';
import { QuickDrive } from '../Hunter/QuickDrive/QuickDrive';
import { Page } from '../Layout/Page/Page';
import { ContinueAppointment } from './ContinueAppointment';
import { ResendQRCodeForm } from './ResendQRCode';
import { ScanQRCode } from './ScanQRCode/ScanQRCode/ScanQRCode';
import {
    Appointment_KeydropRoutePaths,
    AppointmentRoutePaths,
    AppRoutePaths,
    ContinueSessionRoutePaths,
    Customer_AddRoutesPaths,
    CustomerRoutePaths,
    PathName,
    VehiclePickupRoutePaths,
} from '../../helpers/Routes';
import { CustomerDetails } from '../Appointment/Details';

const shouldShowHunter = (url?: string) => {
    if (url) {
        const show = !(
            url.includes(PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.ServicesPreviouslyAdded)) ||
            url.includes(PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.Recalls)) ||
            url.includes(PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.Valuation)) ||
            url.includes(PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.Hunter)) ||
            url.includes(PathName(AppRoutePaths.Customer, CustomerRoutePaths.Add, Customer_AddRoutesPaths.Vehicle))
        );

        console.log('show hunter: ', show);

        return show;
    }
    else {
        return false;
    }
};

export const ContinueSavedSessionKiosk = () => {
    const { pathname } = useResolvedPath('.');
    const navigate = useNavigate();
    const Localization = useLocalization();
    const hasDmsVehicleKey = useHasDmsVehicleKey();
    const location = useLocation();

    const renderHunterRoute = () => {
        let currentUrl = '';
        if (location.search) {
            const search = qs.parse(location.search, { ignoreQueryPrefix: true });
            if ('currentUrl' in search && typeof search.currentUrl === 'string') {
                currentUrl = search.currentUrl;
            }
        }

        return !currentUrl || shouldShowHunter(currentUrl) ? (
            <QuickDrive
                onProceed={() => {
                    currentUrl && navigate(currentUrl);
                }}
                onSkip={() => {
                    currentUrl && navigate(currentUrl, { replace: true });
                }}
            />
        ) : (
            <Navigate replace to={currentUrl} />
        );
    };

    return (
        <Page>
            <Routes>
                <Route
                    path={''}
                    element={
                        <ScanQRCode
                            onProceed={({ currentUrl, mobileCheckInComplete }, appointment) => {
                                if (appointment?.qrCodeType === QRCodeType.vehicleReady) {
                                    if (appointment?.paymentStatus === 'not paid') {
                                        navigate(PathName(AppRoutePaths.VehiclePickUp, VehiclePickupRoutePaths.Payment));
                                    }
                                    else {
                                        navigate(PathName(AppRoutePaths.VehiclePickUp, VehiclePickupRoutePaths.KeydropPickup));
                                    }
                                }
                                else if (appointment?.qrCodeType === QRCodeType.towIn) {
                                    navigate(PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.Keydrop, Appointment_KeydropRoutePaths.Locker));
                                }
                                else {
                                    if (mobileCheckInComplete) {
                                        currentUrl = PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.Summary);
                                    }
                                    if (!currentUrl) {
                                        navigate(PathName(pathname, ContinueSessionRoutePaths.VerifyAppointment));
                                    }
                                    else {
                                        navigate(PathName(pathname, `${ContinueSessionRoutePaths.Continue}?${qs.stringify({ currentUrl })}`));
                                    }
                                }
                            }}
                            onResendClick={() => {
                                navigate(PathName(pathname, ContinueSessionRoutePaths.Resend));
                            }}
                            primaryHeading={Localization.QRCodeScan}
                            secondaryHeading={Localization.ScanYourQRCodeNow}
                            headingIconType={'QR'}
                        />
                    }
                />
                <Route
                    path={PathName(ContinueSessionRoutePaths.Resend, '*')}
                    element={
                        <ResendQRCodeForm
                            onProceed={() => {
                                navigate(pathname);
                            }}
                        />
                    }
                />
                <Route
                    path={PathName(ContinueSessionRoutePaths.Continue, '*')}
                    element={
                        <ContinueAppointment
                            onProceed={() => {
                                navigate(PathName(pathname, `${ContinueSessionRoutePaths.Mileage}${location.search}`));
                            }}
                            onStartOver={() => {
                                navigate(AppRoutePaths.Appointment);
                            }}
                        />
                    }
                />
                <Route
                    path={PathName(ContinueSessionRoutePaths.VerifyAppointment, '*')}
                    element={
                        <ConfirmAppointmentInformation
                            onInformationCorrect={() => {
                                navigate(PathName(pathname, ContinueSessionRoutePaths.VerifyDetails));
                            }}
                            onInformationIncorrect={() => {
                                navigate(PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.Search));
                            }}
                            onExistingCustomer={() => {
                                navigate(PathName(AppRoutePaths.Customer, CustomerRoutePaths.Lookup));
                            }}
                        />
                    }
                />
                <Route
                    path={PathName(ContinueSessionRoutePaths.VerifyDetails, '*')}
                    element={
                        <CustomerDetails
                            onProceed={() => {
                                navigate(PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.Mileage));
                            }}
                        />
                    }
                />
                <Route
                    path={PathName(ContinueSessionRoutePaths.Mileage, '*')}
                    element={
                        <Mileage
                            hideVin={hasDmsVehicleKey}
                            onProceed={() => {
                                navigate(PathName(pathname, `${ContinueSessionRoutePaths.TagNumber}${location.search}`));
                            }}
                        />
                    }
                />
                <Route
                    path={PathName(ContinueSessionRoutePaths.TagNumber, '*')}
                    element={
                        <TagNumber
                            onProceed={() => {
                                navigate(PathName(pathname, `${ContinueSessionRoutePaths.Hunter}${location.search}`));
                            }}
                            onSkip={() => {
                                navigate(PathName(pathname, `${ContinueSessionRoutePaths.Hunter}${location.search}`), { replace: true });
                            }}
                        />
                    }
                />
                <Route path={PathName(ContinueSessionRoutePaths.Hunter, '*')} element={renderHunterRoute()} />
            </Routes>
        </Page>
    );
};
